import React from 'react';
import classNames from 'classnames';
import EnterpriseNavigation from '../../../../components/EnterpriseNavigation';
import { ManagePeopleActions } from '../../../../../AdminDashboard/subrouters/Enterprises/subrouters/Enterprise/pages/ManagePeople/components/ManagePeopleActions';
import FilterControls from '../FilterControls';

import './TeamFilters.styles.scss';
import './TeamFilters.styles.responsive.scss';

type TeamFiltersProps = {
  className?: string;
  withNavigation?: boolean;
  manageColumns?: React.ReactNode;
};

const TeamFilters: React.FC<TeamFiltersProps> = (props) => {
  const { className, withNavigation = true, manageColumns } = props;

  const classes = classNames(
    'team-filters',
    { 'team-filters--with-navigation': withNavigation },
    className,
  );

  return (
    <div className={classes}>
      <div className="filter-row">
        {withNavigation && <EnterpriseNavigation />}
        <ManagePeopleActions />
      </div>

      <FilterControls manageColumns={manageColumns} />
    </div>
  );
};

export default TeamFilters;
